import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { ReportInfo } from '../../../Models/Models/Reports/ReportInfo';
import { ReportBuilder } from '../../../Models/Models/Reports/ReportBuilder';
import { ReportSetting } from '../../../Models/Models/Reports/ReportSetting';

declare var IS_RUNNING_IN_APP_POOL;

export class ClientPortfolioReportClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(reportBuilder: ReportBuilder): Promise<ReportInfo, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/client/ClientPortfolioReport/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { reportBuilder: reportBuilder }

    return AjaxWrapper.post<ReportInfo, any>(url, data);
  }
  public get(): Promise<ReportSetting, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Reports/client/ClientPortfolioReport/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<ReportSetting, any>(url, data);
  }
}

